import * as React from 'react';
import { clsx as cx } from 'clsx';
import { isSameMonth, isSameDay, isAfter, isBefore, startOfMonth, startOfDay } from 'date-fns';
import { format } from '../../../../../internal/utils/date';
import * as styles from './styles.module.css';
var WEEK_DAYS_ARRAY = [1, 2, 3, 4, 5, 6, 0];
export function DayPicker(props) {
  var selected = props.selected,
    onChange = props.onChange,
    month = props.month;
  var now = new Date();
  var min = props.min && startOfDay(props.min);
  var max = props.max && startOfDay(props.max);
  var currentMonth = React.useMemo(function () {
    if (min && isBefore(month, min)) {
      return min;
    }
    if (max && isAfter(month, max)) {
      return max;
    }
    return month;
  }, [month, min, max]);
  var dates = React.useMemo(function () {
    var acc = [];
    var nextDate = startOfMonth(currentMonth);
    var day = nextDate.getDay();
    var prevMonthDays = WEEK_DAYS_ARRAY.indexOf(day);
    nextDate.setDate(nextDate.getDate() - prevMonthDays);

    // Цикл на 6 недель, для того чтобы всегда было равное количество недель
    for (var i = 0; i < 7 * 6; i++) {
      acc.push(new Date(nextDate));
      nextDate.setDate(nextDate.getDate() + 1);
    }
    return acc;
  }, [currentMonth]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['week-days']
  }, dates.slice(0, 7).map(function (date, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles['week-day'],
      "aria-hidden": "true"
    }, format('EEEEEE', date));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['dates']
  }, dates.map(function (date, i) {
    var n = date.getDate();
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      className: cx(styles['date'], selected && isSameDay(date, selected) && styles['selected'], isSameDay(date, now) && styles['today'], !isSameMonth(date, currentMonth) && styles['other-month']),
      onClick: function onClick() {
        onChange(new Date(date));
      },
      "aria-label": format('P', date),
      disabled: isDisabled(date, min, max)
    }, n);
  })));
}
function isDisabled(date, min, max) {
  return !!(min && isBefore(date, min) || max && isAfter(date, max));
}